<template>
<div id="EDSHome"> 
<Subtitle  v-bind:ServiceID="this.AppServiceID" v-bind:MainPage="true">
   <template v-slot:header> 
    <i class="fa fa-medkit"></i><b>EDS Home:</b>
  </template> 
</Subtitle>
  <Card>
<CardBody>
  <p>Any personal health information accessed through the Limited Access Exception Drug Status (EDS) Application is the property of the Government of Saskatchewan. Access to the contents of this site except by agencies <b>AUTHORIZED BY SASKATCHEWAN HEALTH IN WRITING</b> or their authorized employees is strictly prohibited. All transactions are monitored, logged and reviewed. 
  </p>
  <TileNote>
    <strong>Please Note:</strong> Legal action will be taken against any person accessing information without prior approval from Saskatchewan Health AND THOSE WHO UTILIZE THE INFORMATION FOR UNAUTHORIZED OR UNLAWFUL PURPOSES. 
  </TileNote>
 </CardBody>
</Card>
<Card v-if="IsCommBspUser">
  <CardBody>
    <p style="color: red;"><strong>The following messages are applicable to the Community Pharmacy Pilot August 2026 only.</strong></p>
    <p style="color: red;"><strong>NOTE 1:</strong></p>
    <p><strong>Only <u>approved community pilot pharmacies are eligible</u> to submit LAEA EDS approvals. All approved pilot pharmacies and their pharmacists have been registered and have completed the training.</strong></p>
    <p><strong>If you are <u>not an approved community pilot pharmacist</u> or you have not completed the training, <u>DO NOT continue.</u></strong></p>
    <p style="color: red;"><strong>NOTE 2:</strong></p>
    <p><strong><u>Participating Paxlovid pharmacies can continue to ONLY submit Paxlovid</u> EDS approvals through the LAEA. If a participating Paxlovid Pharmacy is also an approved pilot and registered, then they may submit for other drugs.</strong></p>
    <p style="color: red;"><strong>NOTE 3:</strong></p>
    <p><strong>The Drug Plan and Extended Benefits (DPEBB) will audit ALL LAEA entries submitted on a weekly basis. EDS approvals submitted by unauthorized users will be reversed.</strong></p>
    <p><strong>For more information email <a href="mailto:SK.LAEA@health.gov.sk.ca">SK.LAEA@health.gov.sk.ca</a></strong></p>
  </CardBody>
</Card>

</div>
</template>

<script>
import {mapGetters} from 'vuex';
import Subtitle from '@/Common/Default/SubTitle.vue';  
import LayoutDefault from '@/Common/Default/DefaultLayout.vue'; 
import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
export default {


    components: { 
            Card,
            CardBody,
            TileNote ,
            Subtitle
        },
    computed: {
      IsCommBspUser() {
        return this.$store.getters.GetCurrentUser === 'COMMBSP';
      }
    },
    created: function() {
      //console.log(' i am here ')
      this.$emit('update:layout', LayoutDefault);
      const auth = this.$store.getters.IsAuth;
      //console.log(' is auth at eds home ' + auth)
      this.AppServiceID =this.$store.getters.GetDentalID;
      if (auth) { 
        
        this.dateFormat = this.$store.getters.GetDateFormat; 
       
       //console.log('home app service id  = ' + this.AppServiceID)
      }
      //console.log('home app service id  = ' + this.AppServiceID)
    },
    beforeCreate: function() {  
      //console.log('at before')
        this.$store.dispatch('AddServiceID',this.$store.getters.GetDentalID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetDentalID); 
    },
     
}
</script>

<style>

</style>